import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Propinsi from '../../../../utilities/Propinsi'
import KotaKab from '../../../../utilities/KotaKab'
import UPT from '../../../../utilities/UPT'
import KapalService from '../../../../services/kapal/KapalService'
import MasterService from '../../../../services/master/MasterService'
import UserService from '../../../../services/user/UserService'
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { FaBars, FaEdit, FaEye, FaPaperPlane, FaPlus, FaTrash } from 'react-icons/fa'
import DataTable from 'react-data-table-component'
import { AsyncPaginate } from 'react-select-async-paginate'
import { useNavigate } from 'react-router-dom'
import { formatDateTimeLocalDate } from '../../../../utilities/Utils'
import StatusKapal from '../../../../utilities/kapal/StatusKapal'
import ModalLog from '../modal/ModalLog'
import SweetAlert from 'react-bootstrap-sweetalert'

const DraftKapal = () => {
    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAjuKapal']
        },
        {
            name: 'Tanggal Aju',
            cell: row => formatDateTimeLocalDate(row['tanggalAjuKapal'])
        },
        {
            name: 'Nama Kapal',
            cell: row => row['namaKapal']
        },
        {
            name: 'Ukuran (GT)',
            cell: row => row['ukuranKapal']
        },
        {
            name: 'Propinsi',
            cell: row => <Propinsi id={row['kdProp']} />
        },
        {
            name: 'Kota',
            cell: row => <KotaKab id={row['kdKota']} />
        },
        {
            name: 'UPT',
            cell: row => <UPT id={row['kodeUpt']} />
        },
        {
            name: 'Permohonan',
            cell: row => row['statusPermohonan'] === '1' ? 'Baru' : 'Perpanjangan'
        },
        {
            name: 'Status',
            cell: row => <StatusKapal kodeStatus={row['kodeStatus']} />
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className="row">
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat Permohonan</Tooltip>}>
                                <Button size="sm" variant="info" onClick={() => ViewDok(row['nomorAjuKapal'], '0')}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        {row['kodeStatus'] === '000' &&
                            <>
                                <div className="col-12 mb-1">
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Ubah Permohonan</Tooltip>}>
                                        <Button size="sm" variant="warning" onClick={() => ViewDok(row['nomorAjuKapal'], '1')}>
                                            <FaEdit /> Ubah
                                        </Button>
                                    </OverlayTrigger>{' '}
                                </div>
                                <div className="col-12 mb-1">
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Hapus Permohonan</Tooltip>}>
                                        <Button size="sm" variant="danger" onClick={() => HapusDok(row)}>
                                            <FaTrash /> Hapus
                                        </Button>
                                    </OverlayTrigger>{' '}
                                </div>
                                <div className="col-12 mb-1">
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Kirim Permohonan</Tooltip>}>
                                        <Button size="sm" variant="primary" onClick={() => SendDok(row)}>
                                            <FaPaperPlane /> Kirim
                                        </Button>
                                    </OverlayTrigger>{' '}
                                </div>
                            </>
                        }
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >History Permohonan</Tooltip>}>
                                <Button size="sm" variant="secondary" onClick={() => ViewLogStatus(row)}>
                                    <FaBars /> History
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                    </div>
                </>
            )
        }
    ]

    const navigate = useNavigate()

    let kapalService = useMemo(() => new KapalService(), [])
    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const [valueSearchNomorAju, setValueSearchNomorAju] = useState(null)
    const onChangeSearchNomorAju = e => {
        setValueSearchNomorAju(e.target.value)
    }
    const [valueSearchNamaKapal, setValueSearchNamaKapal] = useState(null)
    const onChangeSearchNamaKapal = e => {
        setValueSearchNamaKapal(e.target.value)
    }

    const [keyForSecondSelect, setKeyForSecondSelect] = useState(0)
    const [valueSearchPropOpt, setValueSearchPropOpt] = useState(null)
    const loadOptionPropinsi = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listPropinsi(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePropOpt = e => {
        setValueSearchPropOpt(e)
        setKeyForSecondSelect(prevKey => prevKey + 1)
    }
    const [valueSearchKotaOpt, setValueSearchKotaOpt] = useState(null)
    const loadOptionKota = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listKota(valueSearchPropOpt.kodePropinsi, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeKotaOpt = e => {
        setValueSearchKotaOpt(e)
    }
    const [valueSearchUptOpt, setValueSearchUptOpt] = useState(null)
    const loadOptionUpt = async (search, loadedOption, { page = 1 }) => {
        const response = await userService.listUpt(search, page - 1, size)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeUptOpt = e => {
        setValueSearchUptOpt(e)
    }

    const getListData = useCallback(async (page, size, nomorAju = null, namaKapal = null, kdProp = null, kdKota = null, kodeUpt = null, kodeTrader = null) => {
        setLoading(true)
        try {
            let response
            if (localStorage.getItem("kodeTrader") !== 'null') {
                response = await kapalService.listKapalHeader(nomorAju, namaKapal, kdProp, kdKota, kodeUpt, page, size, localStorage.getItem("kodeTrader"), '000')
            } else {
                if (localStorage.getItem("role") === "1" || localStorage.getItem("role") === "6") {
                    response = await kapalService.listKapalHeader(nomorAju, namaKapal, kdProp, kdKota, kodeUpt, page, size, kodeTrader, '000')
                } else {
                    response = await kapalService.listKapalHeader(nomorAju, namaKapal, kdProp, kdKota, localStorage.getItem("kdUnit"), page, size, kodeTrader, '000')
                }
            }
            setListData(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            setListData([])
        }
        setLoading(false)
    }, [kapalService])

    useEffect(() => {
        getListData(0, 10)
    }, [getListData])

    const handleChangePage = (page) => {
        getListData(page - 1, size, valueSearchNomorAju ? valueSearchNomorAju : null, valueSearchNamaKapal ? valueSearchNamaKapal : null, valueSearchPropOpt ? valueSearchPropOpt.kodePropinsi : null, valueSearchKotaOpt ? valueSearchKotaOpt.kodeKota : null, valueSearchUptOpt ? valueSearchUptOpt.kdUnit : null)
    }

    const handlePerRowsChange = async (size, page) => {
        getListData(page - 1, size, valueSearchNomorAju ? valueSearchNomorAju : null, valueSearchNamaKapal ? valueSearchNamaKapal : null, valueSearchPropOpt ? valueSearchPropOpt.kodePropinsi : null, valueSearchKotaOpt ? valueSearchKotaOpt.kodeKota : null, valueSearchUptOpt ? valueSearchUptOpt.kdUnit : null)
        setSize(size)
    }

    const handleClickCari = () => {
        getListData(0, 10, valueSearchNomorAju ? valueSearchNomorAju : null, valueSearchNamaKapal ? valueSearchNamaKapal : null, valueSearchPropOpt ? valueSearchPropOpt.kodePropinsi : null, valueSearchKotaOpt ? valueSearchKotaOpt.kodeKota : null, valueSearchUptOpt ? valueSearchUptOpt.kdUnit : null)
    }

    const handleClickReset = () => {
        setValueSearchNomorAju('')
        setValueSearchNamaKapal('')
        setValueSearchPropOpt(null)
        setValueSearchKotaOpt(null)
        setValueSearchUptOpt(null)
        setKeyForSecondSelect(0)
        getListData(0, 10)
    }

    const TambahBaru = () => {
        localStorage.removeItem('isEditKapal')
        localStorage.removeItem('nomorAjuKapalStorage')
        localStorage.setItem('isEditKapal', '1')
        navigate('/pbumku/kapal/view-kapal')
    }

    const ViewDok = (noAju, isEdit) => {
        localStorage.removeItem('isEditKapal')
        localStorage.removeItem('nomorAjuKapalStorage')
        localStorage.setItem('nomorAjuKapalStorage', noAju)
        localStorage.setItem('isEditKapal', isEdit)
        navigate('/pbumku/kapal/view-kapal')
    }

    const [showConfirmHapus, setShowConfirmHapus] = useState(false)
    const handleCloseConfirmHapus = () => setShowConfirmHapus(false)
    const [showHapusSuccess, setShowHapusSucces] = useState(false)
    const [showHapusFailed, setShowHapusFailed] = useState(false)
    const [loadingHapus, setLoadingHapus] = useState(false)

    const HapusDok = (rowdata) => {
        setShowConfirmHapus(true)
        setRowData(rowdata)
    }

    const handleClickHapus = async () => {
        setLoadingHapus(true)
        try {
            let jsonHapusData = { ...rowData, status: '131' }

            const response = await kapalService.saveKapalHeader(JSON.stringify(jsonHapusData))
            if (response.data.kode === '200') {
                let dataStatus = {
                    nomorAju: rowData.nomorAju,
                    kodeStatus: '131',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('username')
                }
                await kapalService.saveKapalStatus(JSON.stringify(dataStatus))
                setShowHapusSucces(true)
                setShowConfirmHapus(false)
            } else {
                setShowHapusFailed(true)
            }
        } catch (error) {
            setShowHapusFailed(true)
        }
        setLoadingHapus(false)
    }

    const handleClickHapusSuccess = () => {
        setShowHapusSucces(false)
        getListData(0, 10)
    }

    const handleClickHapusFailed = () => {
        setShowHapusFailed(false)
    }

    const [rowData, setRowData] = useState(null)
    const [showLog, setShowLog] = useState(false)
    const handleCloseLog = () => setShowLog(false)

    const ViewLogStatus = (rowdata) => {
        setRowData(rowdata)
        setShowLog(true)
    }

    const [showConfirmSend, setShowConfirmSend] = useState(false)
    const handleCloseConfirmSend = () => setShowConfirmSend(false)
    const [showSendSuccess, setShowSendSucces] = useState(false)
    const [showSendFailed, setShowSendFailed] = useState(false)
    const [loadingSend, setLoadingSend] = useState(false)

    const SendDok = (rowdata) => {
        setShowConfirmSend(true)
        setRowData(rowdata)
    }

    const handleClickSend = async () => {
        setLoadingSend(true)
        // setShowConfirmSend(false)
        try {
            // console.log(rowData)
            let jsonKirimData = {
                ...rowData,
                kodeStatus: '010',
                updatedBy: localStorage.getItem("userId"),
                updatedDate: new Date()
            }

            const response = await kapalService.saveKapalHeader(JSON.stringify(jsonKirimData))
            if (response.data.kode === '200') {
                setShowSendSucces(true)
                setShowConfirmSend(false)

                let dataStatus = {
                    nomorAjuKapal: rowData.nomorAjuKapal,
                    kodeStatus: '010',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('userId')
                }
                await kapalService.saveKapalStatus(JSON.stringify(dataStatus))

                let jsonDisposisi = {
                    idDisposisi: 1,
                    nomorAjuKapal: rowData.nomorAjuKapal,
                    createdAt: new Date()
                }
                await kapalService.savePenugasan(jsonDisposisi)

            } else {
                setShowSendFailed(true)
            }
        } catch (error) {
            setShowSendFailed(true)
        }
        // console.log(noAju)
        setLoadingSend(false)
    }

    const handleClickSendSuccess = () => {
        setShowSendSucces(false)
        getListData(0, 10)
    }

    const handleClickSendFailed = () => {
        setShowSendFailed(false)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="Nomor Aju" className="form-control-sm" value={valueSearchNomorAju} onChange={onChangeSearchNomorAju} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="Nama Kapal" className="form-control-sm" value={valueSearchNamaKapal} onChange={onChangeSearchNamaKapal} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Propinsi</Form.Label>
                                            <Col sm="9">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionPropinsi}
                                                    value={valueSearchPropOpt}
                                                    getOptionLabel={(option) => option.uraianPropinsi}
                                                    getOptionValue={(option) => option.kodePropinsi}
                                                    additional={{
                                                        page: 1
                                                    }}
                                                    onChange={onChangePropOpt}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Kota</Form.Label>
                                            <Col sm="9">
                                                <AsyncPaginate
                                                    key={keyForSecondSelect}
                                                    loadOptions={loadOptionKota}
                                                    value={valueSearchKotaOpt}
                                                    getOptionLabel={(option) => option.uraianKota}
                                                    getOptionValue={(option) => option.kodeKota}
                                                    additional={{
                                                        page: 1
                                                    }}
                                                    onChange={onChangeKotaOpt}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">UPT</Form.Label>
                                            <Col sm="9">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionUpt}
                                                    value={valueSearchUptOpt}
                                                    getOptionValue={(option) => option.kdUnit}
                                                    getOptionLabel={(option) => option.nmPendekBaru +  ' d/h ' + option.nmUnit}
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    onChange={onChangeUptOpt}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari()}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Permohonan Kapal</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Button type="button" variant="primary" size="sm" onClick={() => TambahBaru()}><FaPlus /> Tambah</Button>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listData}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalLog showLog={showLog} handleCloseLog={handleCloseLog} datappm={rowData} />
            {
                showConfirmSend &&
                <SweetAlert
                    title="Kirim Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSend ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Kirim...
                            </>
                        ) : (
                            "Kirim"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSend}
                    onCancel={handleCloseConfirmSend}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSend}
                >
                    {loadingSend && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Kirim data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSendSuccess &&
                <SweetAlert
                    success
                    title="Kirim Data Berhasil"
                    onConfirm={handleClickSendSuccess}
                    btnSize="sm"
                />
            }
            {
                showSendFailed &&
                <SweetAlert
                    danger
                    title="Kirim Data Gagal"
                    onConfirm={handleClickSendFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmHapus &&
                <SweetAlert
                    title="Hapus Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingHapus ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Hapus...
                            </>
                        ) : (
                            "Hapus"
                        )
                    }
                    confirmBtnBsStyle="danger"
                    cancelBtnText="Kembali"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickHapus}
                    onCancel={handleCloseConfirmHapus}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                >
                    {loadingHapus && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Hapus, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showHapusSuccess &&
                <SweetAlert
                    success
                    title="Hapus Permohonan Berhasil"
                    onConfirm={handleClickHapusSuccess}
                    btnSize="sm"
                />
            }
            {
                showHapusFailed &&
                <SweetAlert
                    danger
                    title="Hapus Permohonan Gagal"
                    onConfirm={handleClickHapusFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default DraftKapal